export const DISPLAY_NAME_MAX = 40

export type NamePrefs = {
  displayName?: string | null
  showFullName?: boolean | null
}

const CJK = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/u

export function cleanDisplayName(raw: string | null | undefined): string | undefined {
  const s = (raw ?? '')
    .replace(/[\p{Cc}\p{Cf}\u2028\u2029]/gu, (c) => (c === '\u200d' ? c : ''))
    .replace(/\s+/g, ' ')
    .trim()
  return s ? [...s].slice(0, DISPLAY_NAME_MAX).join('').trim() : undefined
}

function initial(word: string): string {
  return `${word.match(/\p{L}/u)![0].toLocaleUpperCase()}.`
}

// "Gary Tracey" → "Gary T.". CJK names are often entered family-first, so only
// the first token is shown and no initial is added; single words stay as is.
export function shortName(fullName: string | null | undefined): string {
  const all = (fullName ?? '').trim().split(/\s+/).filter(Boolean)
  const words = all.filter((w) => /\p{L}/u.test(w))
  const [first, ...rest] = words
  if (!first) return all.join(' ')
  if (CJK.test(first)) return first
  const last = rest.filter((w) => !SUFFIX.test(w)).pop()
  return last ? `${first} ${initial(last)}` : first
}

const SUFFIX = /^(jr|sr|ii|iii|iv|phd|md)\.?,?$/i

// What other people see. Self and coach/client pairs use the full name instead.
export function publicName(
  fullName: string | null | undefined,
  prefs: NamePrefs | null | undefined,
  fallback = 'Someone',
): string {
  const chosen = cleanDisplayName(prefs?.displayName)
  if (chosen) return chosen
  const full = (fullName ?? '').trim().replace(/\s+/g, ' ')
  if (prefs?.showFullName) return full || fallback
  return shortName(full) || fallback
}
